// import React, { useEffect, useState } from 'react';
// import './auditCreation.css';
// import ShareAuditOptions from './inspection-mode/ShareAuditOptions';
// import { Navigate, useNavigate, useParams } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Divider from './Divider';
// import { Box, Grid, Card, CardContent, Typography, Button } from '@mui/material';
// import { useSelector } from 'react-redux';
// const AuditCreation = () => {
//   const check = `${process.env.PUBLIC_URL}/custom-icons/success_pink.png`;
//   const copy = `${process.env.PUBLIC_URL}/custom-icons/pink-copy-icon.png`;
//   const clock_icon = `${process.env.PUBLIC_URL}/custom-icons/clock.png`;
//   const or_icon = `${process.env.PUBLIC_URL}/custom-icons/or.png`;
//   const [reqUrl, setReqUrl] = useState(null);
//   const uid = useSelector((state) => state.imagesStore.user_userID);
//   console.log("38", uid);
//   const { audit_id } = useParams();
//   const closeTab = () => {
//     // window.close();
//     navigate('/auditList')
//   };
//   useEffect(
//     () => {
//       const hostname = window.location.hostname;
//       const port = window.location.port;
//       let baseURL;
//       if (port !== '') {
//         baseURL = `https://${hostname}:${port}`;
//       } else {
//         baseURL = `https://${hostname}`;
//       }

//       const url = `${baseURL}/audit/inspection/mode/${audit_id}`;
//       setReqUrl(url);
//     },
//     [audit_id]
//   );
//   const navigate = useNavigate();
//   const handleNavigate = () => {
//     window.location.href = reqUrl;

//   };

//   const handleCopy = () => {
//     navigator.clipboard
//       .writeText(reqUrl)
//       .then(() => {
//         toast.success('Link Copied!', {
//           position: 'bottom-center',
//           autoClose: 1000,
//           type: 'default',
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: false,
//           draggable: true,
//           className: 'custom-toast',
//         });
//       })
//       .catch(err => {
//         console.error('Failed to copy: ', err);
//       });
//   };

//   return (
//     <div className="audit-creation-parent">

//       <div className="audit-creation-child">
//         <ToastContainer />
//         <img
//           src={check}
//           alt="success"
//           style={{
//             width: "50px",
//             height: "50px"
//           }}
//         />
//         <p
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             flexDirection: 'column',
//             gap: '1rem',
//             fontSize: '1.7rem',
//             textAlign: 'center',
//             color: 'black',
//             // padding: '1rem 0.6rem 1rem 0.6rem',
//             fontWeight: '600',
//             fontFamily: 'Barlow Condensed',
//           }}
//         >
//           Audit created successfully{' '}
//         </p>
//         <div className="audit-creation-card">
//           <Typography
//             variant="h6"
//             fontWeight="bold"
//             fontFamily="Montserrat, sans-serif"
//             sx={{
//               fontSize: '1rem',
//               mb: 0,
//               fontWeight: '700',
//               fontFamily: 'Roboto',
//             }}
//           >
//             Inspection Link
//           </Typography>
//           <p>Share the link for the audit</p>
//           <ShareAuditOptions auditUrl={reqUrl} />
//           <button
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               gap: '0.2rem',
//               // border: '1.5px solid #FF0083',
//               padding: '0.2rem 1.2rem',
//               backgroundColor: 'white',
//               borderRadius: '5px',
//               width: '100%',
//               cursor: 'pointer',
//             }}
//             onClick={handleCopy}
//           >
//             <img
//               src={copy}
//               style={{ width: '1rem', height: '1rem' }}
//               alt="Share Icon"
//             />
//             <p
//               style={{
//                 fontSize: '1rem',
//                 fontFamily: "'Montserrat', sans-serif",
//                 color: '#FF0083',
//                 padding: '0.5rem',
//                 cursor: 'pointer',
//               }}
//             >
//               Copy Link
//             </p>
//           </button>
//         </div>
//         {/* <Divider /> */}
//         <img src={or_icon} alt="or" style={{ width: "160px", height: "auto", objectFit: "contain" }} />

//         <Card
//           sx={{
//             height: '135px',
//             mb: 1,
//             width: '100%',
//             borderRadius: '5px',
//             boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//             border: '1px solid #e0e0e0',
//             maxWidth: '340px',
//             position: 'relative', // For positioning the availability label
//           }}
//         >
//           <CardContent sx={{ padding: '5px 10px', margin: '0.1rem' }}>
//             <Grid container alignItems="center" marginTop="6px">
//               <Grid item xs={8}>
//                 <Typography
//                   variant="h6"
//                   fontWeight="bold"
//                   fontFamily="Montserrat, sans-serif"
//                   sx={{
//                     fontSize: '1rem',
//                     mb: 0,
//                     fontWeight: '700',
//                     fontFamily: 'Roboto',
//                   }}
//                 >
//                   Start the inspection
//                 </Typography>
//               </Grid>
//               <Grid item xs={4} sx={{ textAlign: 'right' }}>
//                 <img
//                   src={clock_icon}
//                   alt="clock icon"
//                   style={{
//                     width: '14px',
//                     height: '14px',
//                     verticalAlign: 'middle',
//                     marginRight: '3px',
//                     color: '#999999',
//                   }}
//                 />
//                 <Typography
//                   variant="caption"
//                   color="textSecondary"
//                   fontFamily="Montserrat, sans-serif"
//                   sx={{ fontSize: '12px' }}
//                 >
//                   Approx. 10m
//                 </Typography>
//               </Grid>
//             </Grid>

//             <Typography
//               variant="body2"
//               color="textSecondary"
//               fontFamily="Montserrat, sans-serif"
//               sx={{
//                 mt: 0.5,
//                 mb: 0.5,
//                 lineHeight: 1.3,
//                 fontSize: '13px',
//               }}
//             >
//               Start the inspection now
//             </Typography>

//             <Box
//               mt={1.5}
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'flex-end',
//                 paddingBottom: '4px',
//               }}
//             >

//               <button
//                 // style={{
//                 //   display: 'flex',
//                 //   alignItems: 'center',
//                 //   justifyContent: 'center',
//                 //   gap: '0.2rem',
//                 //   // border: "1.5px solid #FF0083",
//                 //   padding: '0.4rem 1rem',
//                 //   backgroundColor: '#FF0083',
//                 //   borderRadius: '5px',
//                 //   width: '100%',
//                 //   cursor: 'pointer',
//                 // }}
//                 onClick={() => handleNavigate()}
//                  className="start-inspection-btn"
//               >
//                 {/* <img src={tick} style={{ width: "1.2rem", height: "1.2rem" }} alt="Share Icon" /> */}
//                 <span
//                   style={{
//                     fontSize: '1rem',
//                     fontFamily: "'Montserrat', sans-serif",
//                     color: 'white',
//                     padding: '0.2rem',
//                     cursor: 'pointer',
//                   }}
//                 >
//                   Start the inspection
//                 </span>
//               </button>

//             </Box>
//           </CardContent>
//         </Card>
//         <button
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '0.2rem',
//             border: '1.5px solid #FF0083',
//             padding: '0rem 1rem',
//             backgroundColor: 'white',
//             borderRadius: '3px',
//             opacity: '0.9',
//             width: '100%',
//             maxWidth: '340px',
//             position: "absolute",
//             bottom: "1rem"
//           }}
//           onClick={closeTab}
//         >
//           <span
//             style={{
//               fontSize: '0.9rem',
//               fontFamily: "'Montserrat', sans-serif",
//               color: '#FF0083',
//               padding: '0.5rem',
//               cursor: 'pointer',
//             }}
//           >
//             Close
//           </span>
//         </button>
//       </div>

//     </div>
//   );
// };

// export default AuditCreation;

import React, { useEffect, useState } from 'react';
import './auditCreation.css';
import ShareAuditOptions from './inspection-mode/ShareAuditOptions';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Box, Grid, Card, CardContent, Typography, Button } from '@mui/material';
import { useSelector } from 'react-redux';

const AuditCreation = () => {
  const check = `${process.env.PUBLIC_URL}/custom-icons/success_pink.png`;
  const copy = `${process.env.PUBLIC_URL}/custom-icons/pink-copy-icon.png`;
  const clock_icon = `${process.env.PUBLIC_URL}/custom-icons/clock.png`;
  const or_icon = `${process.env.PUBLIC_URL}/custom-icons/or.png`;

  const [reqUrl, setReqUrl] = useState(null);
  const uid = useSelector((state) => state.imagesStore.user_userID);
  const { audit_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const hostname = window.location.hostname;
    const port = window.location.port;
    const baseURL = port !== '' ? `https://${hostname}:${port}` : `https://${hostname}`;
    setReqUrl(`${baseURL}/audit/inspection/mode/${audit_id}`);
  }, [audit_id]);

  const handleNavigate = () => {
    window.location.href = reqUrl;
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(reqUrl)
      .then(() => {
        toast.success('Link Copied!', {
          position: 'bottom-center',
          autoClose: 1000,
        });
      })
      .catch(err => console.error('Failed to copy: ', err));
  };

  const closeTab = () => {
    navigate('/auditList');
  };

  return (
    <div className="audit-creation-parent">
      <ToastContainer />
      <Grid container justifyContent="center" spacing={2} className="audit-creation-child">
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Box textAlign="center">
            <img src={check} alt="success" style={{ width: '40px', height: '40px', marginTop: '10px' }} />
            <Typography variant="h5" fontWeight="600" fontFamily="Barlow Condensed" mt={2}>
              Audit created successfully
            </Typography>
          </Box>

          <Card sx={{ mt: 3, padding: 2, borderRadius: 2 }}>
            <Typography variant="h6" fontWeight="700" fontFamily="Roboto">
              Inspection Link
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Share the link for the audit
            </Typography>
            <ShareAuditOptions auditUrl={reqUrl} />
            <Button
              variant="text"
              fullWidth
              startIcon={<img src={copy} alt="Copy Icon" style={{ width: '16px', height: '16px' }} />}
              onClick={handleCopy}
              sx={{
                mt: 2,
                textTransform: 'none',
                fontFamily: "'Montserrat', sans-serif",
                color: '#FF0083',
                // borderColor: '#FF0083',
                // '&:hover': { backgroundColor: 'rgba(255, 0, 131, 0.1)' },
              }}
            >
              Copy Link
            </Button>
          </Card>

          <Box textAlign="center" mt={3}>
            <img src={or_icon} alt="or" style={{ width: '160px', height: 'auto', objectFit: 'contain' }} />
          </Box>

          <Card sx={{ mt: 2, padding: 1, borderRadius: 2 }}>
            <CardContent>
              <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                  <Typography variant="h6" fontWeight="700" fontFamily="Roboto">
                    Start the inspection
                  </Typography>
                </Grid>
                <Grid item>
                  <img src={clock_icon} alt="clock icon" style={{ width: '14px', height: '14px' }} />
                  <Typography variant="caption" color="textSecondary" ml={0.5}>
                    Approx. 10m
                  </Typography>
                </Grid>
              </Grid>
              <Typography variant="body2" color="textSecondary" mt={1}>
                Start the inspection now
              </Typography>
              <Button
                fullWidth
                variant="contained"
                onClick={handleNavigate}
                sx={{
                  mt: 2,
                  textTransform: 'none',
                  backgroundColor: '#FF0083',
                  fontFamily: "'Montserrat', sans-serif",
                  '&:hover': { backgroundColor: '#e00074' },
                }}
              >
                Start the inspection
              </Button>
            </CardContent>
          </Card>


          {/* active */}

          {/* <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              padding: 2,
              // backgroundColor: 'white',
              // boxShadow: '0 -2px 4px rgba(0, 0, 0, 0.1)',
            }}
          >
            <Button
              fullWidth
              variant="outlined"
              onClick={closeTab}
              sx={{
                textTransform: 'none',
                fontFamily: "'Montserrat', sans-serif",
                color: '#FF0083',
                borderColor: '#FF0083',
                // '&:hover': { backgroundColor: 'rgba(255, 0, 131, 0.1)' },
              }}
            >
              Close
            </Button>
          </Box> */}
          <Box
            sx={{
              position: 'fixed', // Fixed to the viewport
              bottom: 0, // Align to the bottom
              left: 0, // Align to the left
              width: '100%', // Full width for proper centering
              display: 'flex',
              justifyContent: 'center',
              // backgroundColor: '#fff', // Optional: Add a background color to distinguish it
              // boxShadow: '0px -2px 5px rgba(0, 0, 0, 0.1)', // Optional: Add shadow for separation
              zIndex: 10, // Ensure it's above other content
              padding: '10px 10px', // Add padding for better spacing
            }}
          >
            <Button
              variant="outlined"
              onClick={closeTab}
              sx={{
                textTransform: 'none',
                fontFamily: "'Montserrat', sans-serif",
                color: '#FF0083',
                borderColor: '#FF0083',
                fontSize: '16px', // Match the font size
                padding: '0px 20px', // Match the padding
                borderRadius: '8px', // Match the rounded corners
                width: '360px', // Match the button width
                height: '40px', // Match the height
                // '&:hover': {
                //   backgroundColor: '#FFEBF4', // Optional hover effect for consistency
                // },
              }}
            >
              Close
            </Button>
          </Box>


        </Grid>
      </Grid>
    </div>
  );
};

export default AuditCreation;
